// extracted by mini-css-extract-plugin
module.exports = {"editor-wrapper":"editor_mainlayout_editor-wrapper__2mF1f","editor-content-display":"editor_mainlayout_editor-content-display__1NVPO"};